<template>
    <v-card class="myprofile-popup">
        <v-card-title primary-title>
            {{memberProfileConstants.TRAINING_CERTIFICATION.EDIT_COURSES_TAKEN}}
            <i class="fas fa-times" @click="cancel(false)" data-qe-id="close_btn"></i>
        </v-card-title>
        <v-card-text class="inner-scrollbar" ref="courseDialogId">
            <v-flex v-for="(course, index) in courses" :key="index" class="course-details">
            <v-form
                :id="index"
                lazy-validation
                :ref="`course-${course.id}`"
                v-model="valid">
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-flex class="form-control">
                            <span class="select-label">{{memberProfileConstants.NAME}} {{memberProfileConstants.ASTERISK}}</span>
                            <span class="select-required">{{memberProfileConstants.REQUIRED}}</span>
                            <v-flex class="autocomplete" v-on:mouseleave="isSearchOpen = false">
                                <v-text-field
                                    :placeholder="memberProfileConstants.TYPE_TO_SEARCH"
                                    :data-qe-id="`course-${index}_name_input`"
                                    @input="getSearchResults(course)"
                                    v-model="course.name"
                                    @keydown.down="onArrowDown"
                                    @keydown.up="onArrowUp"
                                    @keydown.enter="onEnter(course)"
                                    color="ypo_blue"
                                    required
                                    :maxlength="memberProfileConstants.MAX_NAME_COUNT_EIGHTY"
                                    :rules="memberProfileConstants.TRAINING_CERTIFICATION.PLEASE_ENTER_COURSE_NAME"></v-text-field>
                                <v-list
                                    v-if="isSearchVisible(course.name) && course.isSearch"
                                    id="autocomplete-results"
                                    v-show="isSearchOpen"
                                    class="autocomplete-results">
                                    <v-list-tile
                                        class="autocomplete-result"
                                        v-for="(result, i) in results"
                                        :key="i"
                                        :data-qe-id="`course-${index}_search-result-${i}`"
                                        @click="setResult(course, result)"
                                        :class="{ 'is-active': i === arrowCounter }">
                                        <v-list-tile-title v-highlight ="{keyword: course.name, sensitive: false}">
                                        {{ result }}
                                        </v-list-tile-title>
                                    </v-list-tile>
                                </v-list>
                            </v-flex>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-flex class="form-control">
                            <span class="select-label">{{memberProfileConstants.WEBSITE}}</span>
                            <v-text-field
                                height="40"
                                :data-qe-id="`course-${index}_website_input`"
                                :placeholder="memberProfileConstants.WEBSITE"
                                v-model="course.url"
                                color="ypo_blue"
                                :rules="memberProfileConstants.WEBSITE_URL_RULE"
                                @input="edit(course)"></v-text-field>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-flex class="form-control">
                            <span class="select-label">{{memberProfileConstants.LOCATION}}</span>
                            <v-text-field
                                height="40"
                                :data-qe-id="`course-${index}_location_input`"
                                :placeholder="memberProfileConstants.LOCATION"
                                v-model="course.location"
                                color="ypo_blue"
                                @input="edit(course)"></v-text-field>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm6>
                        <v-flex class="form-control">
                            <span class="select-label">{{memberProfileConstants.START_DATE}}</span>
                            <v-layout row wrap>
                                <v-flex xs6>
                                    <v-autocomplete
                                        attach
                                        :data-qe-id="`course-${index}_start-month`"
                                        height="40"
                                        color="ypo_blue"
                                        :items="getFullMonthNames()"
                                        v-model="course.startMonth"
                                        :placeholder="memberProfileConstants.MONTH"
                                        @input="edit(course)"></v-autocomplete>
                                </v-flex>
                                <v-flex xs6>
                                    <v-flex class="form-control">
                                        <v-autocomplete
                                            :data-qe-id="`course-${index}_start-year`"
                                            attach
                                            height="40"
                                            color="ypo_blue"
                                            v-model="course.startYear"
                                            :items="getListOfYears()"
                                            :placeholder="memberProfileConstants.YEAR"
                                            @input="edit(course)"></v-autocomplete>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-flex>
                    <v-flex xs12 sm6 class="end-date">
                        <v-flex class="form-control">
                        <span class="select-label">{{memberProfileConstants.END_DATE}}</span>
                        <v-layout row wrap>
                            <v-flex xs6>
                                <v-autocomplete
                                    :data-qe-id="`course-${index}_end-month`"
                                    attach
                                    height="40"
                                    color="ypo_blue"
                                    :items="getFullMonthNames()"
                                    v-model="course.endMonth"
                                    :placeholder="memberProfileConstants.MONTH"
                                    @input="edit(course)"></v-autocomplete>
                            </v-flex>
                            <v-flex xs6>
                                <v-flex class="form-control">
                                    <v-autocomplete
                                        :data-qe-id="`course-${index}_end-year`"
                                        attach
                                        height="40"
                                        color="ypo_blue"
                                        :items="getListOfYears()"
                                        v-model="course.endYear"
                                        :placeholder="memberProfileConstants.YEAR"
                                        @input="edit(course)"></v-autocomplete>
                                </v-flex>
                            </v-flex>
                        </v-layout>
                        <span class="end-date__validation" v-if="invalidDate">{{memberProfileConstants.END_DATE_MUST_BE_GREATER_THAN_START_DATE}}</span>
                    </v-flex>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm6>
                        <v-flex class="form-control">
                            <span class="select-label">{{memberProfileConstants.INDUSTRY}}</span>
                            <v-autocomplete
                                :data-qe-id="`course-${index}_industry`"
                                attach
                                height="40"
                                color="ypo_blue"
                                v-model="course.industryCategory"
                                :items="Object.keys(industory).sort()"
                                v-on:input="edit(course)"
                                :placeholder="memberProfileConstants.INDUSTRY"></v-autocomplete>
                        </v-flex>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-flex class="form-control">
                            <span class="select-label">{{memberProfileConstants.SUB_INDUSTRY}}</span>
                            <v-autocomplete
                                :data-qe-id="`course-${index}_sub-industry`"
                                attach
                                height="40"
                                color="ypo_blue"
                                v-model="course.subIndustryCategory"
                                :items="course.subIndustry"
                                :placeholder="memberProfileConstants.SUB_INDUSTRY"
                                :no-data-text="noSubIndustry(course.subIndustry, course.industryCategory)"
                                v-on:input="edit(course)"></v-autocomplete>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-flex class="form-control">
                            <span class="select-label">{{memberProfileConstants.TOPIC}}</span>
                            <v-text-field
                                height="40"
                                :data-qe-id="`course-${index}_topic`"
                                :placeholder="memberProfileConstants.TOPIC"
                                v-model="course.topic"
                                :maxlength="memberProfileConstants.MAX_NAME_LENGTH"
                                color="ypo_blue"
                                @input="edit(course)"></v-text-field>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-flex class="form-control">
                            <span class="select-label">{{memberProfileConstants.DESCRIPTION}}</span>
                            <v-text-field class="text-number"
                                height="40"
                                :data-qe-id="`course-${index}_description`"
                                :placeholder="memberProfileConstants.DESCRIPTION"
                                v-model="course.description"
                                color="ypo_blue"
                                :counter="255"
                                :maxlength="memberProfileConstants.MAX_LENGTH"
                                @input="edit(course)"></v-text-field>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex class="btn-row mt-3">
                        <v-btn
                            class="primary_btn"
                            v-if="!course.isEditDialog"
                            :disabled="!course.isAdd"
                            :data-qe-id="`course-${index}_add-course`"
                            @click="addCourse(course)">
                            <i class="fas fa-plus-circle mr-2"></i>{{memberProfileConstants.ADD_MORE}}
                        </v-btn>
                        <v-btn
                            small
                            class="primary_btn"
                            :data-qe-id="`course-${index}_delete-course`"
                            @click="deleteCourse(course.id, index)"
                            :disabled="course.isDelete">
                            <i class="fas fa-trash-alt mr-2"></i>{{appCommonConstants.DELETE}}
                        </v-btn>
                        <v-flex class="save-to-profile" v-model="course.isSuccess" v-if="course.isSuccess">
                            <i class="fas fa-check"></i> <span>{{memberProfileConstants.SAVED_TO_PROFILE}}</span>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <v-dialog v-model="deleteInformationDialog" lazy absolute content-class="post-actions">
                    <v-card>
                        <v-flex tag="h6">{{memberProfileConstants.DIALOG_CONFIRMATION_TITLE}}
                            <v-btn icon @click="deleteInformationDialog=false" data-qe-id="close_dialog_btn">
                                <v-icon size="20">close</v-icon>
                            </v-btn>
                        </v-flex>
                        <v-flex tag="p">
                            {{memberProfileConstants.DIALOG_CONFIRMATION_DESC}}
                        </v-flex>
                        <v-flex text-xs-right>
                            <status-bar :action="deleteCourseAction"></status-bar>
                            <v-flex ma-1>
                                <v-btn flat @click="deleteInformationDialog = false" class="primary_btn transparent"
                                    data-qe-id="cancel_dialog_btn">
                                    {{memberProfileConstants.CANCEL}}
                                </v-btn>
                                <v-btn dark @click="deleteInformation()" class="primary_btn"
                                    data-qe-id="save_dialog_btn">
                                    {{memberProfileConstants.CONTINUE}}
                                </v-btn>
                            </v-flex>
                        </v-flex>
                    </v-card>
                </v-dialog>
            </v-form>
            </v-flex>
        </v-card-text>
        <status-bar :action="editCourseAction"></status-bar>
        <status-bar :action="saveCourseAction"></status-bar>
        <v-card-actions>
            <v-flex text-xs-right pa-3>
                <v-flex>
                    <v-btn class="primary_btn transparent" @click="cancel(false)" data-qe-id="course_cancel_btn">
                        {{appCommonConstants.CANCEL}}
                    </v-btn>
                    <v-btn class="primary_btn" :disabled="!valid || invalidDate || !courses[0].isSave"
                        data-qe-id="course_save_btn"
                        @click="saveCourse()">
                        {{appCommonConstants.DONE}}
                    </v-btn>
                </v-flex>
            </v-flex>
        </v-card-actions>
    </v-card>
</template>

<script>
import { memberProfileConstants, compareStartAndEndYears, noSubIndustry, filterResults, TrainingandCertActions } from "../memberProfile.constants.js";
import { mapState, mapActions, mapGetters } from "vuex";
import { storeAction } from "../../../store/storeActions.constant";
import { storeGetters } from "../../../store/storeGetters.constant";
import { getFullMonthNames, getListOfYears } from "../../../common/utils/dateTime.js";
import { appCommonConstants } from "../../appCommon.constants.js";
import StatusBar from "../../StatusBar/StatusBar";
import { uuid } from 'vue-uuid';
import Vue from 'vue';

export default {
    name: "CourseDialog",
    data: () => ({
        appCommonConstants,
        memberProfileConstants,
        noSubIndustry,
        filterResults,
        uuid: uuid.v1(),
        subIndustry: [],
        isSearchOpen: false,
        results: [],
        isSearchLoading: false,
        arrowCounter: 0,
        getFullMonthNames,
        getListOfYears,
        startMonth: '',
        startYear: '',
        startDate: null,
        endMonth: '',
        endYear: '',
        endDate: null,
        valid: false,
        deleteInformationDialog: false,
        courseId: null,
        courseDeleteIndex: null,
        invalidDate: false,
        postBody: {
            type: null,
            name: null,
        },
    }),
    components: {
        StatusBar,
    },
    props: {
        memberId: {
            type: String,
            required: true,
        },
        courses: {
            type: Array,
            required: false,
        },
        isCourseEditDialog: {
            type: Boolean,
            required: false,
        },
        course: {
            type: Object,
            required: false,
        },
    },
    methods: {
        ...mapActions({ ...TrainingandCertActions }),
        edit(course) {
            course.isEdit = true;
            course.subIndustry = this.industory[course.industryCategory];
            this.invalidDate = compareStartAndEndYears(course);
        },
        addCourse(course) {
            const [ref] = this.$refs[`course-null`];
            if (ref.validate()) {
                course.isEditDialog = false;
                course.id = this.generateGUID();
                course.personId = this.memberId;
                course.isEdit = false;
                course.type = this.memberProfileConstants.COURSE;
                this.setStartDate(course);
                this.setEndDate(course);
                const postBody = [{
                    ...course,
                }];
                this.saveTrainingAndCertification(postBody)
                    .then(() => {
                        this.search = '';
                        ref.resetValidation();
                        course.isDelete = false;
                        course.isAdd = true;
                        course.isSuccess = true;
                        course.isEditDialog = true;
                        course.isSearch = false;
                        course.isSave = true;
                        const index = this.courses.length;
                        //takes a bit for dom to actually update
                        setTimeout(() => {
                            document.getElementById(index).scrollIntoView();
                        }, 100);
                        this.courses.push(Vue.util.extend({}, this.course));
                    });
            }
        },
        deleteCourse(courseId, index) {
            this.deleteInformationDialog = true;
            this.courseId = courseId;
            this.courseDeleteIndex = index;
        },
        deleteInformation() {
            const parms = {
                companyId: this.courseId,
                personId: this.memberId,
            };
            this.deleteTrainingAndCertification(parms)
                .then(() => {
                    this.deleteInformationDialog = false;
                    if (this.courseDeleteIndex <= 0 && this.courses.length === 1) {
                        this.$emit('click', false);
                    } else {
                        Vue.delete(this.courses, this.courseDeleteIndex);
                    }
                    this.scrollTop();
                });
        },
        saveCourse() {
            if (this.isCourseEditDialog) {
                const [ref] = this.$refs[`course-${this.courses[0].id}`];
                if (ref.validate()) {
                    this.courses[0].type = this.memberProfileConstants.COURSE;
                    this.setStartDate(this.courses[0]);
                    this.setEndDate(this.courses[0]);
                    const postBody = {
                        ...this.courses[0],
                    };
                    postBody.personId = this.memberId;
                    this.updateTrainingAndCertification(postBody) 
                        .then(() => {
                            ref.resetValidation();
                            this.$emit('click', false);
                            this.scrollTop();
                        });
                }
            } else {
                const [ref] = this.$refs[`course-null`];
                if (ref.validate()) {
                    const postbody = this.courses.filter(x => x.isEdit === true);
                    postbody.forEach((x) => {
                        if (x.id === null) {
                            x.id = this.generateGUID();
                            x.type = this.memberProfileConstants.COURSE;
                            this.setStartDate(x);
                            this.setEndDate(x);
                        }
                        x.personId = this.memberId;
                    });
                    this.saveTrainingAndCertification(postbody) 
                    .then(() => {
                        ref.resetValidation();
                        this.$emit('click', false);
                        this.scrollTop();
                    });
                }
            }
        },
        setStartDate(course) {
            if (course.startMonth && course.startYear) {
                course.startDate = `${course.startMonth} ${course.startYear}`;
            } else {
                course.startDate = null;
            }
        },
        setEndDate(course) {
            if (course.endMonth && course.endYear) {
                course.endDate = `${course.endMonth} ${course.endYear}`;
            } else {
                course.endDate = null;
            }
        },
        generateGUID() {
            return uuid.v1();
        },
        cancel(value) {
            this.resetValidation();
            this.$emit('click', value);
            this.scrollTop();
        },
        resetValidation() {
            this.courses.forEach((x) => {
                const [ref] = this.$refs[`course-${x.id}`];
                ref.resetValidation();
            });
            this.invalidDate = false;
        },
        getSearchResults(course) {
            course.isEdit = true;
            course.isAdd = true;
            course.isSave = true;
            this.isSave = false;
            course.isSearch = true;
            if (course.name.length >= this.memberProfileConstants.THREE) {
                this.postBody.type = this.memberProfileConstants.COURSE;
                this.postBody.name = course.name;
                this.searchExternalConnection(this.postBody)
                    .then(() => {
                            this.isSearchLoading = false;
                            this.results = this.filterResults(this.courseAndCertificateSearchResult, course.name);
                            this.isSearchOpen = true;
                    });
            }
        },
        isSearchVisible(courseName) {
            if (courseName !== undefined && courseName !== null) {
                return courseName.length >= this.memberProfileConstants.THREE && this.results.length;
            }
            return false;
        },
        setResult(course, result) {
            course.name = result;
            this.isSearchOpen = false;
        },
        onArrowDown() {
            if (this.arrowCounter < this.results.length) {
                this.arrowCounter = this.arrowCounter + 1;
            }
        },
        onArrowUp() {
            if (this.arrowCounter > 0) {
                this.arrowCounter = this.arrowCounter - 1;
            }
        },
        onEnter(course) {
            course.name = this.results[this.arrowCounter];
            this.isSearchOpen = false;
            this.arrowCounter = -1;
        },
        scrollTop() {
            if (this.$refs.courseDialogId) {
                this.$refs.courseDialogId.scrollTop = 0;
            }
        },
    },
    computed: {
        ...mapState("actionState", ["actions"]),
        ...mapGetters({
            industory: `memberProfile/${storeGetters.externalConnectionIndustry}`,
            courseAndCertificateSearchResult: `memberProfile/${storeGetters.courseAndCertificateSearchResult}`,
        }),
        saveCourseAction() {
            return this.actions[storeAction.saveTrainingAndCertification];
        },
        editCourseAction() {
            return this.actions[storeAction.updateTrainingAndCertification];
        },
        deleteCourseAction() {
            return this.actions[storeAction.deleteTrainingAndCertification];
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../../common/styles/_colors.scss";

.course-details {
    border-bottom: 2px solid $ypo-gray;
    margin-bottom: 20px;
    &:last-child {
        border-bottom: none;
        margin-bottom: 0;
    }
    .end-date {
        position: relative;
        &__validation{
            position: absolute;
            color: $ypo-red;
            font-size: 12px;
            bottom: 0;
        }
    }
}

.v-card {
    .select-required {
        color: $ypo-blue;
        font-size: 14px;
        font-weight: bold;
        line-height: 20px;
        margin-left: 600px;
        @media (max-width: 767px){
            display: none;
        }
    }
}
</style>
